import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ExternalLinkClickEvent,
  getBookstoreLinkClickEventProperties,
} from '®shared/list-item/events';

import { BookstoreAndAvailability } from './bookstore-and-availability';

/**
 * A component that displays the current resource's bookstore availability.
 **/
@Component({
  selector: 'rl-bookstore-availability',
  templateUrl: './bookstore-availability.component.html',
})
export class BookstoreAvailabilityComponent {
  @Input() bookstoreAvailability: BookstoreAndAvailability[];
  @Output() onlineResourceClick = new EventEmitter<ExternalLinkClickEvent>();

  trackExternalLinkClick(
    bookstoreAndAvailability: BookstoreAndAvailability,
  ): void {
    if (
      !bookstoreAndAvailability.availability ||
      !bookstoreAndAvailability.availability.data
    ) {
      return;
    }

    const { label } = bookstoreAndAvailability.bookstore;
    const { detail_page_url } = bookstoreAndAvailability.availability.data;

    this.onlineResourceClick.emit(
      getBookstoreLinkClickEventProperties(label, detail_page_url),
    );
  }
}
